// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"195":"78ecf751","557":"5c638d41","787":"e72a8928"}[chunkId] + ".chunk.js";
};